import { Inject, Injectable, Optional } from '@angular/core';
import { AppLoaderConfig, IAppLoaderConfig } from '@shared/request-loader/interfaces';

@Injectable({
  providedIn: 'root',
})
export class AppLoaderService {
  public loadingConfig: IAppLoaderConfig;

  constructor(@Optional() @Inject('loadingConfig') private config: IAppLoaderConfig) {
    this.loadingConfig = this.config || new AppLoaderConfig();
  }
}
